import { Dashboard } from "api/model/dashboard/Dashboard";
import { DashboardTabModel } from "api/model/dashboard/DashboardTab";
import { setDashboard } from "store/dashboard-store";

const onDragEndSplice = <T>(result: any, itemsToReorder:  T[]): T[]  => {
  const reorderedItems = Array.from(itemsToReorder);
  const [removed] = reorderedItems.splice(result.source.index, 1);
  reorderedItems.splice(result.destination.index, 0, removed);

  return reorderedItems
}

const updateDashboardTabs = (dashboard: Dashboard, newTabs: Array<DashboardTabModel>) => {

  const updatedDashboard = {
    ...dashboard,
    dashboardTabsJs: newTabs,
  } as Dashboard;
  setDashboard(updatedDashboard);

  return updatedDashboard
}

const tabUpdateInDashboard = (
  dashboardTabs: any[], 
  currentTabIndex: number, 
  updatedTabContent: any
) => {
  return [
    ...dashboardTabs.slice(0, currentTabIndex),
    {
      ...dashboardTabs[currentTabIndex],
      ...updatedTabContent,
    },
    ...dashboardTabs.slice(currentTabIndex + 1),
  ];
};


export {onDragEndSplice, updateDashboardTabs, tabUpdateInDashboard}